import type { FeedbackMessages } from './en';

const no: FeedbackMessages = {
  qualified: {
    title: 'Takk for at du deltok i denne undersøkelsen!',
    text: 'Du kan nå lukke nettleservinduet.\n\nVi håper å se deg igjen snart.',
  },
  quotaFull: {
    title: 'Denne undersøkelsen er avsluttet',
    text: 'Takk for din interesse for undersøkelsen vår.\n\nVi har dessverre allerede fått alle svarene vi behøver.\n\nVi håper å se deg i en av våre fremtidige undersøkelser!',
  },
  terminated: {
    title: 'Takk for at du delte din tilbakemelding!',
    text: 'Vi håper å se deg igjen i våre fremtidige undersøkelser. Frem til da ønsker vi deg en fin dag.\n\nVennligst lukk dette nettleservinduet.',
  },
  mismatch: {
    title: 'Takk for din interesse',
    text: 'Du er dessverre ikke i målgruppen for denne spesifikke undersøkelsen.\n\nDu kan lukke denne siden.',
  },
  error: {
    title: 'Vi kan ikke behandle forespørselen din',
    linkProblemDetailed:
      'Lenken du har fulgt har problemer. Vennligst kontroller at lenken i adressefeltet stemmer med den du har fått, og prøv igjen.',
    linkProblemGeneric: 'Lenken du har fulgt har problemer. Vennligst prøv igjen.',
    contactPerson:
      'Hvis problemet fortsetter, vennligst gi personen du fikk lenken fra beskjed om dette problemet.',
  },
};

export default no;
